/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import Select from 'react-select'
import cookie, {load} from 'react-cookies'
import {Link} from 'react-router-dom'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import Page from '../Pagination/Pagination'
import FromToPicker from '../BaseComponent/FromToPicker'
import Loader from '../loaders/loader'
import {productShop} from '../../lib/path'

class UnMatchRemain extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      unMatch: [],
      warehouses: [],
      selectedOption: [],
      planOption: [],
      allPlans: [],
      showSelectBox: false,
      wareCode: [],
      error: '',
      showTable: false,
      wareType: [],
      countAll: '',
      selectedWarehouse: [],
      fromDate: '',
      toDate: '',
      timesInterval: []
    }
  }

  submit(e) {
    e.preventDefault()
  }

  onResultFetched(data) {
    this.setState({
      unMatch: data
    })
  }

  handleChange = (selectedOption) => {
    var wareCode = []
    this.setState({selectedOption})
    if (selectedOption.length == '0') {
      this.setState({
        selectedWarehouse: []
      })
    } else {
      console.log(`Option selected:`, selectedOption)

      for (let prop of selectedOption) {
        wareCode.push(prop.id)
        this.setState({
          selectedWarehouse: wareCode
        })
        sessionStorage.setItem('wareCode', JSON.stringify(wareCode))
      }
    }

    // alert(JSON.stringify(selectedOption))
  }

  componentDidMount() {
    http.get(`public/base/type/timeIntervals`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          timesInterval: response.data.object
        })
      }
    })

    http
      .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_WAREHOUSE}`, {})
      .then((response) => {
        if (response.data.error == null) {
          var result = response.data.object
          for (let i = 0; i < result.length; i++) {
            result[i]['value'] = result[i].id
            result[i]['label'] = result[i].id + ' - ' + result[i].name + ' ( ' + result[i].typePrimaryName + ' ) '
          }
          this.setState({
            warehouses: response.data.object
          })
        }
        // alert(JSON.stringify(response))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    http
      .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_PRIMARYWAREHOUSE}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            wareType: response.data.object
          })
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  searchUnMatch(e) {
    var typePrimary = document.getElementById('typePrimary').value
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    var getWareCode = JSON.parse(sessionStorage.getItem('wareCode'))
    var planTimeType = document.getElementById('planTimeType').value
    let {selectedWarehouse} = this.state
    var from = this.state.fromDate
    var to = this.state.toDate

    if (from == '' && to == '' && planTimeType == '' && selectedWarehouse.length == '0' && typePrimary == '') {
      message.error('حداقل یک فیلتر وارد شود')
    } else if ((from != '' || from == null) && isNaN(from)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((to != '' || to == null) && isNaN(to)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      this.setState({
        loading: true
      })

      sessionStorage.setItem(
        'params',
        `planDateMin=${from == '' ? '' : from}&planDateMax=${
          to == '' ? '' : to
        }&timeIntervalId=${planTimeType}&warehouseIds=${
          selectedWarehouse == null ? [] : selectedWarehouse
        }&primaryWarehouseId=${typePrimary}`
      )

      http
        .get(
          `${
            WAREHOUSE.WAREHOUSE_REPORT_INCOMPLATIBLE_DELIVERYREMAIN
          }?export=false&pageNumber=1&pageSize=10&warehouseIds=${
            selectedWarehouse == null ? [] : selectedWarehouse
          }&primaryWarehouseId=${typePrimary}&planDateMin=${from == '' ? '' : from}&planDateMax=${
            to == '' ? '' : to
          }&timeIntervalId=${planTimeType}`,
          {}
        )
        .then((response) => {
          // alert(JSON.stringify(response.data));

          if (response.data.error == null && response.data.object.result.length > '0') {
            this.setState({
              unMatch: response.data.object.result,
              showTable: true,
              countAll: response.data.object.countAll,
              loading: false
            })
          } else if (response.data.error == 'EMPTY_RESULTS') {
            message.success('هیچ مغایرتی وجود ندارد')
            this.setState({
              showTable: false,
              loading: false
            })
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
          this.setState({
            loading: false
          })
        })
    }
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  render() {
    const {selectedOption, loading} = this.state
    var params = sessionStorage.getItem('params')
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>مغایرت موجودی و پارت تحویل</li>
          </ul>

          <div className="basketFilterComponent">
            <div className="filterInputs">
              <FromToPicker
                onChangeFromDate={this.handleChangeFromDate}
                onChangeToDate={this.handleChangeToDate}
                fromLabel="تاریخ شروع از"
                toLabel="تاریخ شروع تا"
                fromId="from"
                toId="to"
              />

              <div className="formComponent">
                <label>شیفت زمانی :</label>
                <select className="form-control" id="planTimeType">
                  <option value="">-------</option>
                  {this.state.timesInterval.map((shift, index) => (
                    <option value={shift.timeIntervalId}>{shift.timeStart + ' تا ' + shift.timeEnd}</option>
                  ))}
                </select>
              </div>
              <div className="formComponent">
                <label>انبار را انتخاب کنید</label>
                <Select
                  value={selectedOption}
                  onChange={this.handleChange}
                  options={this.state.warehouses}
                  isMulti={true}
                  placeholder="------"
                />
              </div>

              <div className="formComponent">
                <label>نوع انبار </label>
                <select className="form-control" id="typePrimary" name="typePrimary">
                  <option value="">---------</option>
                  {this.state.wareType.map((wareType, index) => (
                    <option key={index} value={wareType.id} selected={wareType.id == '3' ? true : false}>
                      {wareType.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="filterOption">
              <button className="confirmFilter" onClick={this.searchUnMatch.bind(this)}>
                جست و جو
              </button>
            </div>
          </div>

          <div style={this.state.showTable ? {display: 'block'} : {display: 'none'}}>
            <div className="tableComponent">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>انبار</td>
                    <td>نوع انبار</td>
                    <td>نام محصول</td>
                    <td>کد محصول</td>
                    <td>بارکد محصول</td>
                    <td>تعداد سفارش</td>
                    <td>تعداد موجودی</td>
                  </tr>
                  {this.state.unMatch.map((unmatch, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{unmatch.warehouseName}</td>
                      <td>{unmatch.typePrimaryName}</td>
                      <td>
                        <a target="_blank" href={productShop({articleId: unmatch.articleId})}>
                          {unmatch.productName}
                        </a>
                      </td>
                      <td>{unmatch.articleId}</td>
                      <td>{unmatch.productCode}</td>
                      <td>{unmatch.deliveryQuantity}</td>
                      <td>{unmatch.remainQuantity}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.countAll}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={WAREHOUSE.WAREHOUSE_REPORT_INCOMPLATIBLE_DELIVERYREMAIN}
                  urlParams={params}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default UnMatchRemain
